import BSDefaultLayout from "./bootstrap/default";
import BSAdminLayout from "./bootstrap/admin";
import BSBlankLayout from "./bootstrap/blank";
import PublicLayout from "./bootstrap/PublicLayout";
import AdminSuperLayout from "./bootstrap/AdminSuperLayout";
import ResellersLayout from "./bootstrap/ResellerLayout";


const layouts = {
    default: BSDefaultLayout,
    admin: BSAdminLayout,
    blank: BSBlankLayout,
    public: PublicLayout,
    BSBlankLayout,
    BSAdminLayout,
    BSDefaultLayout,
    instantPollsAdmin: AdminSuperLayout,
    reseller:ResellersLayout
};

const LayoutWrapper = (props) => {
    // to get the text value of the assigned layout of each component
    const Layout = layouts[props.children.type.layout];
    // if we have a registered layout render children with said layout
    if (Layout != null) {
        return <Layout {...props}>{props.children}</Layout>;
    }
    // if not render children with fragment
    return <BSDefaultLayout {...props}>{props.children}</BSDefaultLayout>;
};

export default LayoutWrapper;